import { render, staticRenderFns } from "./EditButtonTabStyle.vue?vue&type=template&id=0ec658fb&scoped=true&"
import script from "./EditButtonTabStyle.vue?vue&type=script&lang=js&"
export * from "./EditButtonTabStyle.vue?vue&type=script&lang=js&"
import style0 from "./EditButtonTabStyle.vue?vue&type=style&index=0&id=0ec658fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec658fb",
  null
  
)

export default component.exports